// extracted by mini-css-extract-plugin
export default {"title":"Brands_title__ZLhzV"};